import { DataBean } from "../DataBean";

export class RawMaterialByProductionOrder extends DataBean {
    
    


    public async getRawMaterialCatalogByProductionOrder(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRawMaterialCatalogByProductionOrder_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }
  

}